// extracted by mini-css-extract-plugin
module.exports = {"input":"form-input_input__2FgYC"};